import cx from 'clsx';
import Link from 'next/link';

import { TITLE_HEADING_H1 } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const SectionContainer: Component = ({
  children,
  description,
  className,
  containerRef,
  descriptionClassName,
  contentClassName,
  title,
  titleLink,
  titleAfterContent,
  titleAfterContentClassName,
  titleAsideContent,
  titleAsideContentClassName,
  titleContainerClassName,
  titleTextClassName,
  titleHeading: TitleHeading = TITLE_HEADING_H1,
  trackingSelector,
}) => (
  <div
    ref={containerRef}
    className={cx(
      styles.containerRoot,
      title && styles.hasTitle,
      className,
    )}
    data-tracking-selector={trackingSelector}>
    <div
      className={cx(
        styles.containerHeader,
        titleContainerClassName,
      )}>
      {(title || titleLink) && (
        <TitleHeading
          className={styles.containerTitle}>
          <div
            className={styles.markTitle} />
          <span
            className={cx(
              styles.textTitle,
              titleTextClassName,
            )}>
            {titleLink
              ? (
                <Link
                  href={titleLink}>
                  {title}
                </Link>
              )
              : (
                title
              )}

          </span>
        </TitleHeading>
      )}
      {
        titleAfterContent && (
          <div
            className={cx(
              styles.containerTitlerAfterContent,
              titleAfterContentClassName,
            )}>
            {titleAfterContent}
          </div>
        )
      }
      {titleAsideContent && (
        <aside
          className={cx(
            styles.containerTitleAsideContent,
            titleAsideContentClassName,
          )}>
          {titleAsideContent}
        </aside>
      )}
    </div>
    {description && (
      <div
        className={descriptionClassName}>
        {description}
      </div>
    )}
    <div
      className={contentClassName}>
      {children}
    </div>
  </div>
);
